export default {
      id: "icon-eye-usage",
      viewBox: "0 0 24 24",
      url: "/" + "sprite.svg#icon-eye",
      toString: function () {
        return this.url;
      }
    }